<template>
  <div class="hp_space_between">
    <div class="left">
      <div class="filtrate">
        <div class="row_demo">
          <div class="name">科室</div>
          <div class="dept-name">
            <div
              v-for="(item, index) in baseDepts"
              :key="index"
              @click="selChange(0, index)"
              :class="{ active: item.selected }"
              class="tag"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="row_demo">
          <div class="name">级别</div>
          <div class="dept-name">
            <div
              v-for="(item, index) in lvs"
              :key="index"
              @click="selChange(1, index)"
              :class="{ active: item.selected }"
              class="tag"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
      <template v-if="list && list.length > 0">
        <div class="offices">
          <div
            @click="$toPage('/registered/dept/' + item.id)"
            v-for="(item, index) in list"
            :key="index"
            class="office_demo hp_space_between"
          >
            <div class="detail hp_flex">
              <div class="hospitalImg hp_center">
                <img v-if="item.image" :src="base_url + item.image" alt />
                <img v-else src="@/assets/default-img/dept.png" alt />
              </div>

              <div>
                <div class="hp_cz_center" style="margin-bottom:20px">
                  <span class="name">{{ item.name }}</span>
                  <span v-if="item.important" class="trait">
                    {{ getImportantName(item.important) }}
                  </span>
                </div>
                <div class="hp_cz_center" style="margin-bottom:20px">
                  <span class="public">医院：{{ item.hospitalName }}</span>
                  <span class="lv">[ {{ item.levelName }} ]</span>
                </div>
                <div class="hp_cz_center" style="margin-bottom:20px">
                  <span class="public">地址：{{ item.address }}</span>
                </div>
                <div class="hp_cz_center" style="margin-bottom:20px">
                  <span class="public">电话：{{ item.tel }}</span>
                </div>
              </div>
            </div>
            <div class="orders">
              <div class="txt">已预约人次</div>
              <div class="num">{{ item.registCount }}次</div>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px;">
          <a-pagination
            show-quick-jumper
            :current="currPage"
            :total="totalCount"
            :defaultPageSize="form.pageSize"
            @change="onChange"
          />
        </div>
      </template>
      <noData v-else></noData>
    </div>
  </div>
</template>
<script>
import { ls } from '@/utils/tool'
import { getDepts } from '@/api/office'
import { submitFavorite } from '@/api/registered'
import noData from '@/components/NoData'
export default {
  components: {
    noData,
  },
  data() {
    return {
      moreActive: false,
      baseDepts: [],
      lvs: [
        {
          text: '国家重点',
          value: 1,
        },
        {
          text: '省重点',
          value: 2,
        },
        {
          text: '市重点',
          value: 3,
        },
        {
          text: '区重点',
          value: 4,
        },
        {
          text: '普通科室',
          value: 5,
        },
      ],
      list: [],
      sysUser: ls.get('sysUser'),
      form: {
        baseIds: '',
        importants: '',
        pageNum: 1,
        pageSize: 5,
      },
      currPage: 1,
      totalCount: 1,
    }
  },
  mounted() {
    this.selList()
    this.init()
  },
  methods: {
    getImportantName(val) {
      var txt
      this.lvs.forEach((item) => {
        if (item.value == val) {
          txt = item.text
        }
      })
      return txt
    },
    onChange(pageNumber) {
      this.form.pageNum = pageNumber
      this.init()
    },
    async init() {
      var res = await getDepts(this.form)
      console.log('res====', res)
      this.list = res.data.list
      this.totalCount = res.data.totalCount
      this.currPage = res.data.currPage
    },
    selChange(num, index) {
      if (num === 0) {
        this.baseDepts[index].selected = !this.baseDepts[index].selected
        var baseIds = []
        this.baseDepts.forEach((item) => {
          if (item.selected) {
            baseIds.push(item.id)
          }
        })
        this.form.baseIds = baseIds.toString()
      } else if (num === 1) {
        this.lvs[index].selected = !this.lvs[index].selected
        this.form.importants = ''
        var importants = []
        this.lvs.forEach((item) => {
          if (item.selected) {
            importants.push(item.value)
          }
        })
        this.form.importants = importants.toString()
      }
      this.form.pageNum = 1
      this.init()
    },
    selList() {
      this.baseDepts = ls.get('baseDepts').map((item) => {
        return { ...item, selected: false }
      })
      this.lvs = this.lvs.map((item) => {
        return { ...item, selected: false }
      })
    },
    async collectThis(id) {
      let data = {
        memberId: this.sysUser.id,
        objectId: id,
        objectType: 2,
      }
      let res = await submitFavorite(data)
      this.$message.success('收藏成功！')
      this.init()
    },
  },
}
</script>
<style lang="less" scoped>
.left {
  width: 911px;
  .filtrate {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 0px 21px 0px rgba(154, 200, 255, 0.32);
    padding-left: 16px;
    padding-right: 25px;
    padding-top: 32px;
    font-size: 16px;
    color: #0079fe;
    .row_demo {
      position: relative;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;
      .ant-row {
        width: 95%;
        overflow: hidden;
        transition: height 0.5s linear;
        -webkit-transition: height 0.5s linear;
        -moz-transition: height 0.5s linear;
        -ms-transition: height 0.5s linear;
      }
      .dept-name {
        flex: 1;
        flex-wrap: wrap;
        display: flex;
      }
      .name {
        color: #333333;
        margin-right: 40px;
        font-weight: bold;
      }
      .more {
        color: #999999;
        position: absolute;
        right: 25px;
        top: 0;
        cursor: pointer;
      }
      .tag {
        cursor: pointer;
        margin-right: 39px;
        margin-bottom: 18px;
      }
      .active {
        color: #ff4d4f;
      }
    }
  }
  .offices {
    width: 100%;
    .office_demo {
      cursor: pointer;
      margin-top: 20px;
      padding: 20px;
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0px 21px 0px rgba(154, 200, 255, 0.32);
      border-radius: 10px;
      .detail {
        .hospitalImg {
          width: 160px;
          height: 160px;
          margin-right: 20px;
          overflow: hidden;
          border-radius: 10px;
          img {
            height: 160px;
          }
        }

        .name {
          font-size: 20px;
          color: #333333;
        }
        .trait {
          font-size: 16px;
          color: #ff3b30;
          margin-left: 18px;
        }
        .lv {
          color: #ff9700;
        }
        .public {
          font-size: 16px;
          color: #666666;
        }
      }
      .orders {
        text-align: right;
        .txt {
          font-size: 16px;
          color: #333333;
        }
        .num {
          font-size: 20px;
          font-weight: bold;
          color: #0079fe;
          margin-top: 30px;
        }
        .collect {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          margin-top: 50px;
        }
      }
    }
  }
}
</style>
